import React from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
interface ContainerProps {
  active: boolean;
}
const Container = styled.button<ContainerProps>(({ theme, active }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: theme.fontWeight.medium,
  borderRadius: "4px",
  padding: "8px 12px",
  color: active ? theme.color.white : theme.color.black,
  backgroundColor: active ? theme.color.black : theme.color.white,
  cursor: "pointer",
  transition: "all 0.2s",
  border: `1px solid ${!active ? theme.color.black : "transparent"}`,
  boxSizing: "border-box",
}));

type Prop = {
  title: string;
  active: boolean;
  onClick: () => void;
};
const TabButton = ({ title, active, onClick }: Prop) => {
  const { t } = useTranslation();

  return (
    <Container active={active} onClick={onClick}>
      {t(title)}
    </Container>
  );
};

export default TabButton;
